var _circle, _path, _path2, _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _path5, _path6, _path7, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 466,
    height: 235,
    viewBox: "0 0 466 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 335.5,
    cy: 132.5,
    r: 101.5,
    fill: "#F3E4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115 219H379C379 227.837 371.837 235 363 235H131C122.163 235 115 227.837 115 219Z",
    fill: "#8C8CAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137 100C137 97.2386 139.239 95 142 95H349C351.761 95 354 97.2386 354 100V214H137V100Z",
    fill: "white",
    stroke: "#4A4A68",
    strokeWidth: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 100,
    width: 208,
    height: 119,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.657 134.748C321.329 134.748 321.329 127.939 339 127.939V175.999H-898V171.47C-878.856 171.47 -880.328 173.974 -862.657 173.974C-844.986 173.974 -844.986 166.861 -827.314 166.861C-809.643 166.861 -812.588 169.05 -791.971 169.05C-771.355 169.05 -777.245 173.148 -756.629 173.148C-736.012 173.148 -740.43 171.591 -721.286 171.591C-702.142 171.591 -705.823 164.174 -685.943 164.174C-666.062 164.174 -671.217 166.594 -650.6 166.594C-629.983 166.594 -633.665 169.925 -615.257 169.925C-596.849 169.925 -599.795 158.86 -579.914 158.86C-560.034 158.86 -562.243 162.69 -544.571 162.69C-526.9 162.69 -529.845 157.328 -509.229 157.328C-488.612 157.328 -493.03 160.757 -473.886 160.757C-454.742 160.757 -457.687 146.737 -438.543 146.737C-419.399 146.737 -423.08 150.64 -403.2 150.64C-383.32 150.64 -388.474 153.218 -367.857 153.218C-347.241 153.218 -352.395 146.531 -332.514 146.531C-312.634 146.531 -317.788 149.814 -297.171 149.814C-276.555 149.814 -280.236 144.403 -261.829 144.403C-243.421 144.403 -245.63 135.356 -226.486 135.356C-207.342 135.356 -210.287 150.495 -191.143 150.495C-171.999 150.495 -174.208 139.892 -155.8 139.892C-137.392 139.892 -141.074 144.536 -120.457 144.536C-99.8405 144.536 -104.258 148.707 -85.1143 148.707C-65.9702 148.707 -68.1792 141.801 -49.7714 141.801C-31.3637 141.801 -32.8363 148.367 -14.4286 148.367C3.97916 148.367 1.77023 145.448 20.9143 145.448C40.0583 145.448 37.1131 139.43 56.2571 139.43C75.4012 139.43 72.456 141.837 91.6 141.837C110.744 141.837 109.271 133.046 126.943 133.046C144.614 133.046 141.669 145.096 162.286 145.096C182.902 145.096 177.748 136.913 197.629 136.913C217.509 136.913 214.564 140.281 232.971 140.281C251.379 140.281 249.907 131.891 268.314 131.891C286.722 131.891 285.986 134.748 303.657 134.748Z",
    fill: "#F3E4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 127.939C321.329 127.939 321.329 134.768 303.657 134.768C285.986 134.768 286.722 131.902 268.314 131.902C249.907 131.902 251.379 140.317 232.971 140.317C214.564 140.317 217.509 136.939 197.629 136.939C177.748 136.939 182.902 145.146 162.286 145.146C141.669 145.146 144.614 133.061 126.943 133.061C109.271 133.061 110.744 141.878 91.6 141.878C72.456 141.878 75.4012 139.463 56.2571 139.463C37.1131 139.463 40.0583 145.5 20.9143 145.5C1.77024 145.5 3.97916 148.426 -14.4286 148.426C-32.8363 148.426 -31.3637 141.841 -49.7714 141.841C-68.1792 141.841 -65.9702 148.768 -85.1143 148.768C-104.258 148.768 -99.8405 144.585 -120.457 144.585C-141.074 144.585 -137.392 139.926 -155.8 139.926C-174.208 139.926 -171.999 150.56 -191.143 150.56C-210.287 150.56 -207.342 135.378 -226.486 135.378C-245.63 135.378 -243.421 144.451 -261.829 144.451C-280.236 144.451 -276.555 149.878 -297.171 149.878C-317.788 149.878 -312.634 146.585 -332.514 146.585C-352.395 146.585 -347.24 153.292 -367.857 153.292C-388.474 153.292 -383.32 150.707 -403.2 150.707C-423.08 150.707 -419.399 146.792 -438.543 146.792C-457.687 146.792 -454.742 160.853 -473.886 160.853C-493.03 160.853 -488.612 157.414 -509.229 157.414C-529.845 157.414 -526.9 162.792 -544.571 162.792C-562.243 162.792 -560.034 158.951 -579.914 158.951C-599.795 158.951 -596.849 170.048 -615.257 170.048C-633.665 170.048 -629.983 166.707 -650.6 166.707C-671.217 166.707 -666.063 164.28 -685.943 164.28C-705.823 164.28 -702.142 171.719 -721.286 171.719C-740.43 171.719 -736.012 173.28 -756.629 173.28C-777.245 173.28 -771.355 169.17 -791.971 169.17C-812.588 169.17 -809.643 166.975 -827.314 166.975C-844.986 166.975 -844.986 174.109 -862.657 174.109C-880.329 174.109 -878.856 171.597 -898 171.597",
    stroke: "#A4A4B3",
    strokeWidth: 0.665765
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.332883,
    y: -0.332883,
    width: 5.66577,
    height: 5.66577,
    rx: 2.83288,
    transform: "matrix(-1 0 0 1 307.307 132.407)",
    fill: "#4A4A68",
    stroke: "white",
    strokeWidth: 0.665765
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.332883,
    y: -0.332883,
    width: 5.66577,
    height: 5.66577,
    rx: 2.83288,
    transform: "matrix(-1 0 0 1 268.307 129.437)",
    fill: "#4A4A68",
    stroke: "white",
    strokeWidth: 0.665765
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.332883,
    y: -0.332883,
    width: 5.66577,
    height: 5.66577,
    rx: 2.83288,
    transform: "matrix(-1 0 0 1 342.307 125.387)",
    fill: "#4A4A68",
    stroke: "white",
    strokeWidth: 0.665765
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.332883,
    y: -0.332883,
    width: 5.66577,
    height: 5.66577,
    rx: 2.83288,
    transform: "matrix(-1 0 0 1 238.307 137.537)",
    fill: "#4A4A68",
    stroke: "white",
    strokeWidth: 0.665765
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.332883,
    y: -0.332883,
    width: 5.66577,
    height: 5.66577,
    rx: 2.83288,
    transform: "matrix(-1 0 0 1 201.307 134.297)",
    fill: "#4A4A68",
    stroke: "white",
    strokeWidth: 0.665765
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.997 105.431C149.575 105.431 148.701 105.431 148.555 105.431H148.476V105.603C148.482 106.431 148.651 107.109 149.152 107.701C149.738 108.385 150.583 108.586 151.332 108.994C151.597 109.138 151.901 109.328 151.901 109.678C151.901 110.126 151.563 110.402 150.882 110.402C150.273 110.402 149.603 110.08 149.073 109.626L148.132 110.782C148.87 111.494 149.884 111.856 150.837 111.856C152.589 111.856 153.597 110.782 153.597 109.546C153.597 109.247 153.552 108.943 153.434 108.667C153.276 108.293 153 108 152.668 107.787C152.662 107.782 152.651 107.776 152.645 107.77C152.284 107.534 151.901 107.402 151.507 107.253C151.417 107.218 151.332 107.184 151.242 107.149C150.651 106.908 150.144 106.552 150.02 105.885C150.02 105.874 149.997 105.707 149.997 105.598V105.431Z",
    fill: "#1F1D30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.876 105.161C150.876 105.885 151.451 106.471 152.16 106.471C152.87 106.471 153.445 105.885 153.445 105.161C153.445 104.437 152.87 103.851 152.16 103.851C151.451 103.851 150.876 104.437 150.876 105.161Z",
    fill: "#D092DD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 195,
    width: 15,
    height: 15,
    rx: 2,
    fill: "#D2D2D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 197,
    width: 58,
    height: 2,
    rx: 1,
    fill: "#F3F2F4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 201,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#F3F2F4"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 195,
    width: 15,
    height: 15,
    rx: 2,
    fill: "#D2D2D9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 197,
    width: 65,
    height: 2,
    rx: 1,
    fill: "#F3F2F4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 201,
    width: 21,
    height: 2,
    rx: 1,
    fill: "#F3F2F4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 8.1333,
    y: 82.1333,
    width: 113.867,
    height: 90.2061,
    rx: 4,
    fill: "#D092DD"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 75,
    width: 111.867,
    height: 88.2061,
    rx: 3,
    fill: "white",
    stroke: "#4A4A68",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4352 129.155L31.2057 132.929C30.7427 133.142 30.3911 133.541 30.2403 134.027C30.0886 134.514 30.1509 135.043 30.4113 135.48C36.0578 144.96 46.4093 150.849 57.4244 150.849C69.1954 150.849 79.8844 144.351 85.3187 133.89C85.5537 133.437 85.5861 132.907 85.4064 132.43C85.2267 131.953 84.8531 131.574 84.3779 131.389L75.9449 128.098C75.1199 127.776 74.1826 128.105 73.7398 128.87C70.372 134.673 64.1205 138.279 57.4244 138.279C51.0738 138.279 45.1888 135.108 41.6825 129.798C41.195 129.059 40.2436 128.788 39.4352 129.155ZM57.4244 141.87C64.8789 141.87 71.8696 138.118 76.023 131.983L81.1434 133.982C76.0931 142.219 67.1779 147.257 57.4244 147.257C48.3391 147.257 39.7632 142.733 34.5875 135.329L39.5817 133.039C43.821 138.596 50.382 141.87 57.4244 141.87Z",
    fill: "#665891"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6326 129.419C27.7948 129.902 28.1543 130.294 28.6216 130.496C28.8496 130.595 29.0925 130.644 29.3353 130.644C29.5913 130.644 29.8465 130.589 30.0841 130.481L38.3119 126.707C39.1168 126.337 39.5324 125.436 39.2904 124.583C38.8126 122.901 38.5697 121.165 38.5697 119.424C38.5697 115.384 39.8314 111.53 42.2198 108.278C42.7441 107.564 42.6687 106.573 42.0418 105.946L35.643 99.5474C35.2835 99.1879 34.7899 98.9976 34.2787 99.0239C33.7701 99.0511 33.2967 99.2922 32.9766 99.6885C28.4778 105.255 26 112.264 26 119.424C26 122.826 26.5497 126.189 27.6326 129.419ZM34.5645 103.548L38.4496 107.433C36.1743 111.019 34.9784 115.134 34.9784 119.424C34.9784 120.981 35.1414 122.536 35.4641 124.062L30.4681 126.353C29.8859 124.09 29.5913 121.767 29.5913 119.424C29.5913 113.664 31.3046 108.215 34.5645 103.548Z",
    fill: "#E9E8FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4242 88C50.2634 88 43.2543 90.4778 37.6884 94.9766C37.2921 95.2966 37.051 95.7701 37.0238 96.2787C36.9966 96.7872 37.1869 97.2835 37.5472 97.6429L43.9461 104.042C44.573 104.668 45.5629 104.744 46.2784 104.22C49.5295 101.831 53.3839 100.57 57.4242 100.57C67.8203 100.57 76.2787 109.028 76.2787 119.424C76.2787 120.794 76.1262 122.175 75.8254 123.527C75.6325 124.392 76.0998 125.268 76.9249 125.59L85.3588 128.881C85.5692 128.964 85.791 129.004 86.012 129.004C86.2899 129.004 86.567 128.94 86.8195 128.812C87.2746 128.583 87.6113 128.171 87.7445 127.679C88.4775 124.984 88.8484 122.207 88.8484 119.424C88.8484 102.097 74.7513 88 57.4242 88ZM84.7354 124.783L79.6158 122.784C79.785 121.669 79.8701 120.544 79.8701 119.424C79.8701 107.047 69.801 96.9783 57.4242 96.9783C53.134 96.9783 49.0192 98.1743 45.4331 100.45L41.5481 96.5645C46.2143 93.3046 51.6627 91.5913 57.4242 91.5913C72.7715 91.5913 85.2571 104.077 85.2571 119.424C85.2571 121.222 85.0817 123.016 84.7354 124.783Z",
    fill: "#FFDBDB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 226,
    y: 7,
    width: 199,
    height: 70,
    rx: 4,
    fill: "#D092DD"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 1,
    width: 197,
    height: 68,
    rx: 3,
    fill: "white",
    stroke: "#4A4A68",
    strokeWidth: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 45,
    width: 17.4304,
    height: 22,
    fill: "#E9E8FC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 255.304,
    y: 27,
    width: 17.4304,
    height: 40,
    fill: "#E9E8FC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 276.608,
    y: 36,
    width: 17.4304,
    height: 31,
    fill: "#E9E8FC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 297.911,
    y: 11,
    width: 17.4304,
    height: 56,
    fill: "#E9E8FC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 318.57,
    y: 54,
    width: 17.4304,
    height: 13,
    fill: "#E9E8FC"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 318.304,
    y: 27,
    width: 17.4304,
    height: 40,
    fill: "#E9E8FC"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 339.607,
    y: 36,
    width: 17.4304,
    height: 31,
    fill: "#E9E8FC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 360.911,
    y: 11,
    width: 17.4304,
    height: 56,
    fill: "#E9E8FC"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 381.57,
    y: 54,
    width: 17.4304,
    height: 13,
    fill: "#E9E8FC"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 54.2143,
    width: 17.4304,
    height: 11.7857,
    fill: "#4A4A68"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 255.304,
    y: 44.5714,
    width: 17.4304,
    height: 21.4286,
    fill: "#4A4A68"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 276.608,
    y: 49.3929,
    width: 17.4304,
    height: 16.6071,
    fill: "#4A4A68"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 297.911,
    y: 36,
    width: 17.4304,
    height: 30,
    fill: "#4A4A68"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 318.57,
    y: 59.0357,
    width: 17.4304,
    height: 6.96429,
    fill: "#4A4A68"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 318.304,
    y: 44.5714,
    width: 17.4304,
    height: 21.4286,
    fill: "#4A4A68"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 339.607,
    y: 49.3929,
    width: 17.4304,
    height: 16.6071,
    fill: "#4A4A68"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 360.911,
    y: 36,
    width: 17.4304,
    height: 30,
    fill: "#4A4A68"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 381.57,
    y: 59.0357,
    width: 17.4304,
    height: 6.96429,
    fill: "#4A4A68"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M419.996 121.009H459.028C462.876 121.009 465.986 124.133 466 127.982V155.718C466 159.567 462.876 162.691 459.028 162.705H447.593L440.662 173.637C440.411 174.042 439.965 174.279 439.491 174.279C439.017 174.293 438.57 174.056 438.319 173.651L431.319 162.705H419.982C416.133 162.691 413.009 159.567 413.009 155.718V127.982C413.023 124.133 416.147 121.009 419.996 121.009Z",
    fill: "#E7C8EE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M440.583 155.195H440.308L440.161 155.428L433.23 166.36L433.228 166.365C433.072 166.615 432.79 166.77 432.481 166.77H432.474L432.467 166.77C432.169 166.779 431.891 166.63 431.735 166.378L431.735 166.378L431.731 166.373L424.731 155.426L424.583 155.195H424.31L412.974 155.195C412.974 155.195 412.974 155.195 412.973 155.195C409.399 155.182 406.5 152.281 406.5 148.709V120.973C406.513 117.399 409.414 114.5 412.986 114.5H452.018C455.589 114.5 458.477 117.398 458.491 120.973C458.491 120.974 458.491 120.974 458.491 120.974L458.491 148.709C458.491 152.281 455.591 155.182 452.018 155.195C452.017 155.195 452.017 155.195 452.016 155.195L440.583 155.195Z",
    fill: "white",
    stroke: "#4A4A68"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M441.444 131.221L435.136 125.69C434.558 125.173 433.809 124.887 433.033 124.887C432.258 124.887 431.509 125.173 430.931 125.69L424.622 131.221C424.288 131.519 424.022 131.886 423.841 132.295C423.659 132.705 423.567 133.149 423.571 133.597V142.786C423.571 143.622 423.903 144.425 424.495 145.016C425.086 145.608 425.889 145.94 426.725 145.94H439.342C440.178 145.94 440.98 145.608 441.572 145.016C442.164 144.425 442.496 143.622 442.496 142.786V133.586C442.498 133.14 442.405 132.698 442.224 132.291C442.043 131.883 441.777 131.518 441.444 131.221V131.221ZM435.136 143.837H430.931V138.58C430.931 138.301 431.041 138.034 431.239 137.837C431.436 137.64 431.703 137.529 431.982 137.529H434.085C434.364 137.529 434.631 137.64 434.828 137.837C435.025 138.034 435.136 138.301 435.136 138.58V143.837ZM440.393 142.786C440.393 143.065 440.282 143.332 440.085 143.529C439.888 143.726 439.621 143.837 439.342 143.837H437.239V138.58C437.239 137.744 436.907 136.942 436.315 136.35C435.724 135.758 434.921 135.426 434.085 135.426H431.982C431.145 135.426 430.343 135.758 429.752 136.35C429.16 136.942 428.828 137.744 428.828 138.58V143.837H426.725C426.446 143.837 426.179 143.726 425.982 143.529C425.784 143.332 425.674 143.065 425.674 142.786V133.586C425.674 133.437 425.706 133.289 425.767 133.153C425.829 133.018 425.919 132.896 426.031 132.798L432.339 127.278C432.531 127.109 432.778 127.016 433.033 127.016C433.289 127.016 433.535 127.109 433.727 127.278L440.036 132.798C440.148 132.896 440.238 133.018 440.299 133.153C440.361 133.289 440.393 133.437 440.393 133.586V142.786Z",
    fill: "#4A4A68"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 48.0938,
    fill: "white",
    transform: "matrix(-1 0 0 1 339 127.906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.16ab663101b0d467dc339cd752e2bae6.svg";
export { ForwardRef as ReactComponent };